<template>
  <div v-loading="loading">
    <div v-if="application.status != 'FOLLOWING'" class="success">
      <img
        :src="
          require(`../../assets/${
            (application.status &&
              status.find((item) => item.code == application.status).icon) ||
            'Circle.png'
          }`)
        "
        alt
      />
      <span>
        {{
          application.status &&
          status.find((item) => item.code == application.status).name
        }}
        <br />
        {{
          application.status == "NOT_APPROVED" ? application.returnedReason : ""
        }}
        {{ application.status == "REJECTED" ? application.rejectedReason : "" }}
      </span>
      <span id="preview_message">{{ message }}</span>
    </div>
    <div v-if="application.status == 'FOLLOWING'" class="success">
      <span>{{ $t("message.status.FOLLOWING") }}</span>
      <span id="preview_message">{{ message }}</span>
      <div class="status_afterFile">
        <GradientBtn @click="afterFile">{{
          $t("message.afterFile")
        }}</GradientBtn>
      </div>
    </div>
  </div>
</template>

<script>
import LoginAPI from "../../api/LoginAPI";
import HzmbApplicationAPI from "../../api/HzmbApplicationAPI";
import ApplicationAPI from "../../api/ApplicationAPI";
import DrivIntApplicationAPI from "../../api/DrivIntApplicationAPI";
import ServiceTypeConfigAPI from "../../api/ServiceTypeConfigAPI";
import GradientBtn from "../../components/GradientBtn";
import { wordBreak } from "@/filters";
import HzmbVehDriApplicationChangeAPI from "@/api/HzmbVehDriApplicationChangeAPI";
export default {
  components: { GradientBtn },
  data() {
    return {
      loading: false,
      spNo: null,
      application: {},
      status: [],
      addcountData: {},
      message: "",
    };
  },
  computed: {
    verifyForm() {
      return this.$store.state.verifyForm;
    },
    apiType() {
      const serviceType = localStorage.getItem("serviceType") || null;
      switch (serviceType) {
        case "DRV_LIC_INTER":
          return "/driving";
        case "HZMB_CHANGE_PERSON":
        case "HZMB_CHANGE_COMP":
        case "HZMB_GH_CHANGE_COMP":
          return "/change";
        default:
          return "";
      }
    },
  },
  methods: {
    afterFile() {
      const serviceType = localStorage.getItem("serviceType") || null;
      const changeType = localStorage.getItem("searchChangeType") || null;
      if (serviceType == "DRV_LIC_INTER") {
        this.$router.push("/internationalFiles");
      } else {
        this.$router.push({
          path: "/search/afterFiles",
          query: {
            spNo: this.spNo,
            serviceType: serviceType,
            changeType,
          },
        });
      }
    },
    getDetailsThen(res) {
      this.application = res;
      // 獲取通知訊息
      let documentType =
        (res.documents &&
          res.documents.filter((item) => item.status == "SUPPLEMENTING")) ||
        [];
      documentType = documentType
        .map((item) => {
          return item.documentType[`name${this.$t("message.lan")}`];
        })
        .join("; ");
      // console.log(documentType);
      if (res.status != "FOLLOWING") {
        const status = res.status == "SUBMITTED" ? "SUPPLEMENTED" : res.status;
        this.getMessage(res.id, res.serviceType, status, {
          documentType: documentType,
        });
      }
    },
    getDetails() {
      this.loading = true;
      const serviceType = localStorage.getItem("serviceType") || null;
      const simpleData = this.$store.state.simpleData;
      if (simpleData && simpleData.id) {
        if (
          serviceType == "HZMB_RENEW_PERSON" ||
          serviceType == "HZMB_RENEW_COMPANY"
        ) {
          HzmbApplicationAPI.renewSearch(simpleData.id)
            .then((res) => {
              this.loading = false;
              this.getDetailsThen(res);
            })
            .catch((err) => {
              this.loading = false;
              this.$error(err);
              // console.log(err);
            });
        } else if (serviceType == "DRV_LIC_INTER") {
          DrivIntApplicationAPI.getApplication(simpleData.id)
            .then((res) => {
              this.loading = false;
              this.getDetailsThen(res);
            })
            .catch((err) => {
              this.loading = false;
              this.$error(err);
              // console.log(err);
            });
        } else if (
          [
            "HZMB_CHANGE_PERSON",
            "HZMB_CHANGE_COMP",
            "HZMB_GH_CHANGE_COMP",
          ].includes(serviceType)
        ) {
          HzmbVehDriApplicationChangeAPI.findById(simpleData.id)
            .then((res) => {
              this.loading = false;
              const { hzmbVehDriChangeApplication, supplementDocuments } = res;
              this.getDetailsThen({
                ...hzmbVehDriChangeApplication,
                documents: supplementDocuments,
              });
            })
            .catch((err) => {
              this.loading = false;
              this.$error(err);
            });
        } else {
          HzmbApplicationAPI.firstSearch(simpleData.id)
            .then((res) => {
              this.loading = false;
              this.getDetailsThen(res);
            })
            .catch((err) => {
              this.loading = false;
              this.$error(err);
              // console.log(err);
            });
        }
      } else {
        this.loading = false;
      }
    },
    accountLogin() {
      this.loading = true;
      const serviceType = localStorage.getItem("serviceType") || null;
      const code = this.$route.query.code || null;
      const token =
        sessionStorage.getItem("accountToken") ||
        this.$route.query.token ||
        null;
      LoginAPI.account(code, token, serviceType, false)
        .then((res) => {
          this.loading = false;
          this.addcountData = res.data;
          localStorage.setItem("authentication", res.headers.authentication);
          if (serviceType === "DRV_LIC_INTER") {
            this.getDrivingVss();
          } else if (
            [
              "HZMB_CHANGE_PERSON",
              "HZMB_CHANGE_COMP",
              "HZMB_GH_CHANGE_COMP",
            ].includes(serviceType)
          ) {
            this.getChangeVss();
          } else {
            this.getVss();
          }
        })
        .catch((err) => {
          this.loading = false;
          // console.log(err);
          if (err.code == "-" && err.message == "401 Unauthorized: [no body]") {
            this.$router.push("/search/personal");
          } else {
            this.$error(err);
            this.$router.push("/search/personal");
          }
        });
    },
    // 獲取服務類型詳情
    getServiceDetails(serviceType) {
      this.loading = true;
      ServiceTypeConfigAPI.getDetails(serviceType)
        .then((res) => {
          this.loading = false;
          res.nameTc = wordBreak(res.nameTc);
          res.nameSc = wordBreak(res.nameSc);
          res.namePt = wordBreak(res.namePt);
          res.nameEn = wordBreak(res.nameEn);
          this.$store.commit("changeServiceTypeConfig", res);
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    getVss() {
      const serviceType = localStorage.getItem("serviceType") || null;
      let identType = "BM";
      let identNo = this.addcountData.identityNo;
      const spNo = localStorage.getItem("searchSpNo") || null;
      this.loading = true;
      HzmbApplicationAPI.getVss(
        serviceType,
        identType,
        identNo,
        spNo,
        null,
        null,
        false
      )
        .then((res) => {
          this.loading = false;
          this.getDetails();
        })
        .catch((err) => {
          this.loading = true;
          this.$router.push("/search/personal");
          this.$error(err);
          return false;
        });
    },
    getDrivingVss() {
      const serviceType = localStorage.getItem("serviceType") || null;
      let identType = "BM";
      let identNo = this.addcountData.identityNo;
      const spNo = localStorage.getItem("searchSpNo") || null;
      this.loading = true;
      DrivIntApplicationAPI.check(serviceType, identType, identNo, null, spNo)
        .then((res) => {
          this.loading = false;
          this.getDetails();
        })
        .catch((err) => {
          this.loading = false;
          this.$router.push("/verification/driving/search");
          this.$error(err);
          return false;
        });
    },
    async getChangeVss() {
      try {
        const serviceType = localStorage.getItem("serviceType") || null;
        let identType = "BM";
        let identNo = this.addcountData.identityNo;
        const spNo = localStorage.getItem("searchSpNo") || null;
        const changeType = localStorage.getItem("searchChangeType") || null;
        this.loading = true;
        await HzmbVehDriApplicationChangeAPI.check({
          serviceType,
          identType,
          identNo,
          spNo,
          changeType,
          isFirst: false,
        });
        this.getDetails();
      } catch (error) {
        this.loading = true;
        this.$router.push("/search/personal");
        this.$error(error);
        return false;
      } finally {
        this.loading = false;
      }
    },
    // 獲取通知訊息
    async getMessage(id, serviceType, messageType, parameters) {
      try {
        this.loading = true;
        if (
          [
            "HZMB_CHANGE_PERSON",
            "HZMB_CHANGE_COMP",
            "HZMB_GH_CHANGE_COMP",
          ].includes(serviceType)
        ) {
          const messages = await HzmbVehDriApplicationChangeAPI.message(
            id,
            serviceType,
            messageType,
            parameters
          );
          this.message = messages[this.$t("message.lang")];
        } else {
          const messages = await HzmbApplicationAPI.message(
            id,
            serviceType,
            messageType,
            parameters
          );
          this.message = messages[this.$t("message.lang")];
        }
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    const serviceType = localStorage.getItem("serviceType") || null;
    if (!serviceType) this.$router.push("/search/personal");
    this.status = [
      {
        code: "SUBMITTED",
        name: this.$t("message.status.SUBMITTED"),
        icon: "Success.png",
      },
      { code: "FOLLOWING", name: this.$t("message.status.FOLLOWING") },
      {
        code: "PRE_APPROVED",
        name: this.$t("message.status.PRE_APPROVED"),
        icon: "SuccessfulApproval.png",
      },
      {
        code: "NOT_APPROVED",
        name: this.$t("message.status.NOT_APPROVED"),
        icon: "NotApproved.png",
      },
      {
        code: "APPROVED",
        name: this.$t("message.status.APPROVED"),
        icon: "SuccessfulApproval.png",
      },
      {
        code: "REJECTED",
        name: this.$t("message.status.REJECTED"),
        icon: "NotApproved.png",
      },
    ];

    const spNo = localStorage.getItem("searchSpNo") || null;
    this.spNo = spNo;
    if (serviceType && spNo) {
      const apiType = this.apiType;
      const changeType = localStorage.getItem("searchChangeType") || null;
      this.loading = true;
      ApplicationAPI.getBySpNo(serviceType, spNo, apiType, changeType)
        .then((res) => {
          this.loading = false;
          localStorage.setItem("serviceType", res.serviceType);
          this.$store.commit("changeServiceType", res.serviceType);
          if (!res.applicationNo) {
            this.$message({
              message: this.$t("message.search_spNo_error"),
              type: "error",
            });
            return false;
          }
          this.$store.commit("changeSimpleData", res);
          this.getServiceDetails(res.serviceType);

          const code = this.$route.query.code || null;
          const token = sessionStorage.getItem("accountToken") || null;
          if ((code || token) && res.serviceType) {
            this.accountLogin();
          } else {
            this.getDetails();
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
          // console.log(err);
        });
    }
  },
};
</script>

<style lang="scss" scoped>
// .success {
//   height: 700px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   max-width: 600px;
//   margin: auto;
//   text-align: center;
// }
// .success img {
//   width: 96px;
//   height: auto;
//   margin-bottom: 36px;
// }
// .success span {
//   font-size: 24px;
//   color: #515151;
//   line-height: 35px;
// }
.status_afterFile {
  margin-top: 76px;
}
.gradient_btn {
  width: 300px;
  max-width: 100%;
}
</style>